export default {
  name: 'LiveCompleted',
  props: ['text', 'type']
};